/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsHistogramAxis: {
  name: 'histogram-axis';
  data: string;
} = {
  name: 'histogram-axis',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 1a.5.5 0 0 0-1 0v14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 0-1h-.5V9a.5.5 0 0 0-.5-.5h-3.5V3a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v2.5h-3V1Zm0 5.5v8h12v-5H10a.5.5 0 0 1-.5-.5V3.5h-4V6a.5.5 0 0 1-.5.5H1.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
